export const SHOW_BADGE_TOOL_TIP = 'SHOW_BADGE_TOOL_TIP';

export function showBadgeToolTip(characterName, foundation, earned) {
  return {
    type: SHOW_BADGE_TOOL_TIP,
    payload: {characterName, foundation, earned},
  };
}



// WEBPACK FOOTER //
// ./app/features/sideNavigationBadges/actions/showBadgeToolTip.js